import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppService {
    /**
     * Boolean if the platform is native or not.
     */
    public isApp: boolean;
    /**
     * Only for apps. When the screen size is smaller than 1024 x 600, we assume that it is a mobile phone
     */
    public isPhone: boolean;
    /**
     * Only for apps. When the screen size is bigger than 1024 x 600, we assume that it is a tablet
     */
    public isTablet: boolean;
    /**
     * On a web browser it is always true
     */
    public isPC: boolean;
    /**
     * Specifies whether the current environment is production or not.
     */
    public isProduction: boolean;
    /**
     * Application title
     */
    public title: string;
    /**
     * Version taken from version.json
     */
    public version: string;
    /**
     * Environment - dev or prod
     */
    public env: string;
    /**
     * Represents the URL of the backend server.
     */
    public backendUrl: string;
    /**
     * Name of the project
     */
    public project: string;
    /**
     * URL of homepage
     */
    public homePage: string;

    public async config(
        isProduction: boolean,
        project: string,
        title: string,
        version: string,
        backendUrl: string,
        env: string
    ) {
        this.isProduction = isProduction;
        this.title = title;
        this.version = version;
        this.env = env;
        this.backendUrl = backendUrl;
        this.project = project;
    }
}
